import { createSlice } from '@reduxjs/toolkit';
import { updateReportTemplate } from '../../../rtk-apis/reports/updateReportTemplate';

const initialState = {
  status: '',
  result: null,
  msg: '',
  loading: false,
  error: '',
};

const updateReportTemplateSlice = createSlice({
  name: 'updateReportTemplateSlice',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
      state.error = '';
    },
  },
  extraReducers: builder => {
    builder
      .addCase(updateReportTemplate.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(updateReportTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload;
        state.msg = action?.payload?.msg;
      })
      .addCase(updateReportTemplate.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.result = null;
        state.msg = (action?.payload as string) || 'Something went wrong!';
      });
  },
});

export default updateReportTemplateSlice.reducer;
export const { clearState } = updateReportTemplateSlice.actions;
